import * as types from "./theme.actionsType";

export class Actions {
  static load() {
    let themeStorage = window.localStorage.getItem("SYSTEM_THEME_STORAGE_KEY", true);
    const theme = themeStorage ? themeStorage.replace(/"/g, "") : "theme-default";
    return { type: types.LOAD_THEME, payload: theme };
  }
  static set(theme) {
    window.localStorage.setItem("SYSTEM_THEME_STORAGE_KEY", JSON.stringify(theme.path));
    return { type: types.LOAD_THEME, payload: theme.path };
  }
}

export default Actions;
